<template lang="html">
    <modal dialog="modal-lg" class="dark-top" :footer="false" :headerStyle="{'background-color':currentIntegration.color.main}">
        <div slot="title">
            <h2>Primavera</h2>
        </div>

        <div slot="body">
            <!-- Top area -->
            <top-area :integration="currentIntegration" />

            <steps :currentStep="currentStep" :steps="steps" @switchStep="switchStep"></steps>

            <!-- Lower area -->
            <div class="px-5 pt-4 pb-4">
                <div v-if="getIsPrimaveraSettingsLoading || (isLoading && currentStep !== 1)" class="text-center w-100 p-3 d-flex justify-content-center align-items-center" style="min-height: 328px;">
                    <loader />
                </div>

                <div v-if="!getIsPrimaveraSettingsLoading && currentStep === 1" class="min-section-height d-flex flex-column justify-content-center">
                    <div class="row mb-2 row-height">
                        <label class="col-md-12 p-0">API Endpoint<span class="brand"> * </span>
                            <input
                                type="text"
                                class="bg-lighter w-100"
                                v-model="primaveraData.defaultUrl"
                            />
                        </label>
                        <div v-if="$v.primaveraData.defaultUrl.$invalid" class="error">
                            <span v-if="!$v.primaveraData.defaultUrl.required">API Endpoint is required</span>
                        </div>
                    </div>
                    <div class="row mb-2 row-height">
                        <label class="col-md-12 p-0">Company Name<span class="brand"> * </span>
                            <input
                                type="text"
                                class="bg-lighter w-100"
                                v-model="primaveraData.company"
                            />
                        </label>
                        <div v-if="$v.primaveraData.company.$invalid" class="error">
                            <span v-if="!$v.primaveraData.company.required">Company Name is required</span>
                        </div>
                    </div>
                    <div class="row mb-2 row-height">
                        <div class="col-6 col-sm-6 col-md-6 p-0 pr-2">
                            <label class="full">Username<span class="brand"> * </span>
                                <input
                                    type="text"
                                    class="bg-lighter w-100"
                                    v-model="primaveraData.username"
                                />
                            </label>
                            <div v-if="$v.primaveraData.username.$invalid" class="error">
                                <span v-if="!$v.primaveraData.username.required">Username is required</span>
                            </div>
                        </div>
                        <div class="col-6 col-sm-6 col-md-6 p-0">
                            <label class="full">Password<span class="brand"> * </span>
                                <input
                                    type="password"
                                    class="bg-lighter w-100"
                                    v-model="primaveraData.password"
                                />
                            </label>
                            <div v-if="$v.primaveraData.password.$invalid" class="error">
                                <span v-if="!$v.primaveraData.password.required">Password is required.</span>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-2 row-height">
                        <label class="col-md-12 p-0">Article List ID<span class="brand"> * </span>
                            <input
                                type="text"
                                class="bg-lighter w-100"
                                v-model="primaveraData.defaultArticleListID"
                            />
                        </label>
                        <div v-if="$v.primaveraData.defaultArticleListID.$invalid" class="error">
                            <span v-if="!$v.primaveraData.defaultArticleListID.required">Article List ID is required</span>
                        </div>
                    </div>
                </div>

                <div v-if="!getIsPrimaveraSettingsLoading && currentStep === 2 && !isLoading" class="min-section-height d-flex flex-column justify-content-center">
                    <div class="row mb-2 row-height">
                        <div class="col-6 col-sm-6 col-md-6 p-0 pr-2">
                            <label class="full">Series<span class="brand"> * </span>
                                <v-select
                                    :key="primaveraData.defaultSerie"
                                    label="description"
                                    :value="getSeriesValue(primaveraData.defaultSerie)"
                                    :options="getPrimaveraSeries"
                                    placeholder="Select series"
                                    class="black-text primavera-select"
                                    :disabled="getIsResquestingPrimaveraSeriesLoading || getPrimaveraSeries.length === 0"
                                    @input="seriesInput($event)">
                                </v-select>
                            </label>
                            <div v-if="$v.primaveraData.defaultSerie.$invalid" class="error">
                                <span v-if="!$v.primaveraData.defaultSerie.required">Series is required</span>
                            </div>
                        </div>
                        <div class="col-6 col-sm-6 col-md-6 p-0">
                            <label class="full">Series Map<span class="brand"> * </span>
                                <input
                                    type="text"
                                    class="bg-lighter w-100"
                                    :value="primaveraData.defaultSerieConfiguration"
                                    disabled
                                />
                            </label>
                            <div v-if="$v.primaveraData.defaultSerieConfiguration.$invalid" class="messages error">
                                <span v-if="!$v.primaveraData.defaultSerieConfiguration.required">Series Map is required</span>
                            </div>
                        </div>
                    </div>

                    <div class="row mb-2 d-flex flex-column min-payment-height">
                        <div class="d-flex payment-labels">
                            <label class="col-6 col-sm-6 col-md-6 p-0">Payment Terms<span class="brand"> * </span></label>
                            <label class="col-6 col-sm-6 col-md-6 p-0">Payment Conditions<span class="brand"> * </span></label>
                        </div>
                        <div class="d-flex mb-1 p-0" :class="{'border-bottom-light pb-1': index + 1 !== getDocumentTypes.length}" v-for="type, index in getDocumentTypes">
                            <div class="col-6 col-sm-6 col-md-6 d-flex justify-content-end align-items-center payment-height">
                                <span class="fs-normal bold">
                                    {{`${type.id}: ${type.label}`}}
                                </span>
                            </div>
                            <div class="col-6 col-sm-6 col-md-6 p-0">  
                                <v-select
                                    :ref="index"
                                    label="label"
                                    class="smaller-select"
                                    :value="getPaymentConditionsValue(type)"
                                    placeholder="Select condition"
                                    :options="getPaymentConditions"
                                    :disabled="getIsResquestingPrimaveraSeriesLoading"
                                    @input="paymentConditionsInput($event, type)">
                                </v-select>
                            </div>
                        </div>
                        <div v-if="$v.primaveraData.paymentConditions.$invalid" class="row error payment-height">
                            <span class="col-6 col-sm-6 col-md-6"></span>
                            <span class="col-6 col-sm-6 col-md-6 p-0" v-if="!$v.primaveraData.paymentConditions.required">Payment Conditions are required</span>
                        </div>
                    </div>

                    <div class="row mb-2 row-height">
                        <label class="full col-md-12 p-0">Default Reasons for Credit Notes on Canceled Reservation<span class="brand"> * </span>
                            <v-select
                                :key="primaveraData.defaultChargebackReason"
                                :value="getChargeBackReasonValue(primaveraData.defaultChargebackReason)"
                                :options="getChargeBackReason"
                                :disabled="getIsChargeBackReasonsLoading || getChargeBackReason.length === 0"
                                class="col-md-12 p-0 black-text primavera-select"
                                label="label"
                                placeholder="Select reason"
                                @input="chargeBackReasonInput($event)">
                            </v-select>
                        </label>
                        <div v-if="$v.primaveraData.defaultChargebackReason.$invalid" class="col-md-12 p-0 error">
                            <span v-if="!$v.primaveraData.defaultChargebackReason.required">Default Reasons is required</span>
                        </div>
                    </div>
                </div>

                <div v-if="!getIsPrimaveraSettingsLoading && currentStep === 3 && !isLoading" class="min-section-height d-flex flex-column justify-content-center">
                    <div class="row mb-2 col-md-12 p-0">
                        <div class="bold fs-large">
                            End Customer Data Configuration 
                        </div>
                        <span class="fs-small dark">
                            (These details will be automatically applied to direct bookings without other customer information provided).
                        </span>
                    </div>
                    <div class="row mb-2 row-height">
                        <div class="col-6 col-sm-6 col-md-6 p-0 pr-2">
                            <label class="full">Name<span class="brand"> * </span></label>
                            <input
                                type="text"
                                class="bg-lighter w-100"
                                v-model="primaveraData.defaultEndCustomerName"
                            />
                            <div v-if="$v.primaveraData.defaultEndCustomerName.$invalid" class="error">
                                <span v-if="!$v.primaveraData.defaultEndCustomerName.required">Name is required</span>
                            </div>
                        </div>
                        <div class="col-6 col-sm-6 col-md-6 p-0">
                            <label class="full">VAT Number<span class="brand"> * </span></label>
                            <input
                                type="number"
                                class="bg-lighter w-100"
                                v-model.number="primaveraData.defaultEndCustomerTaxNumber"
                            />
                            <div v-if="$v.primaveraData.defaultEndCustomerTaxNumber.$invalid" class="error">
                                <span v-if="!$v.primaveraData.defaultEndCustomerTaxNumber.required">Company Name is required</span>
                            </div>
                        </div>
                    </div>

                    <div class="row mb-2 d-flex flex-column">
                        <div class="d-flex payment-labels">
                            <label class="col-md-6 p-0">Payment Types<span class="brand"> * </span></label>
                            <label class="col-md-6 p-0">Primavera Payment type<span class="brand"> * </span></label>
                        </div>
                        <div ref="parentContainer" class="payment-types">
                            <div class="d-flex mb-1 p-0" :class="{'border-bottom-light pb-1': index + 1 !== getPaymentTypes.length}" v-for="type, index in getPaymentTypes" >
                                <div class="col-6 col-sm-6 col-md-6 d-flex justify-content-end align-items-center payment-height">
                                    <span class="fs-small bold">
                                        {{type.label}}
                                    </span>
                                </div>
                                <div class="col-6 col-sm-6 col-md-6 pl-2">  
                                    <v-select
                                        :ref="'select-' + index"
                                        label="label"
                                        class="smaller-select"
                                        :value="getErpPaymentTypesValue(type)"
                                        :class="{'open-up': isOpenUp[index]}"
                                        placeholder="Select condition"
                                        :options="getErpPaymentTypes"
                                        :disabled="getIsResquestingErpPaymentTypeLoading"
                                        @input="erpPaymentTypesInput($event, type)"
                                        @click.native="toggleDirection(index)">
                                    </v-select>
                                </div>
                            </div>
                        </div>
                        <div v-if="$v.primaveraData.paymentTypes.$invalid" class="row error payment-height">
                            <span class="col-6 col-sm-6 col-md-6"></span>
                            <span class="col-6 col-sm-6 col-md-6 p-0" v-if="!$v.primaveraData.paymentTypes.required">Primavera Payment type is required</span>
                        </div>
                    </div>
                </div>

                <div v-if="!getIsPrimaveraSettingsLoading && currentStep === 4 && !isLoading" class="min-section-height">
                    <div class="row mb-2 col-md-12 p-0">
                        <div class="bold fs-large">
                            Customer Identifier Configuration
                        </div>
                        <span class="fs-normal darker mt-3">
                            Define a prefix for customer identifiers. The final code will have a maximum of 12 characters.
                        </span>
                    </div>

                    <div class="row mb-2 row-height mt-3">
                        <div class="col-12 col-sm-12 col-md-12 p-0 pr-2">
                            <label class="full">Customer Identifier Prefix (optional, max. 3 characters)</label>
                            
                            <input
                                type="text"
                                class="bg-lighter w-100 mt-1"
                                v-model="primaveraData.codePrefix"
                                placeholder="PL"
                            />

                            <div v-if="$v.primaveraData.codePrefix.$invalid" class="error">
                                <span v-if="!$v.primaveraData.codePrefix.maxLength">Maximum length of 3 characters.</span>
                            </div>
                        </div>
                    </div>

                     <div class="row mb-2 col-md-12 p-0 mt-3">
                        <div class="fs-small color-1">
                            If you define a prefix, the customer identifier will be adjusted to maintain the 12-character limit in total.
                        </div>
                        <span class="fs-small color-1">
                            If no prefix is provided, the code will use the last 12 digits of the VAT number.
                        </span>
                    </div>
                </div>

                <bottom-area
                    :isIntegrated="true"
                    :isInvoicing="true"
                    @disableIntegration="clickDeactivate()"
                    @saveIntegration="savePrimaveraData()"
                    @nextStep="nextStep()"
                    :showNextBtn="showNextBtn"
                    :disableNextBtn="disableNextBtn"
                    @prevStep="prevStep()"
                    :showPrevBtn="showPrevBtn"
                    @testConnection="testConnection()"
                    :showConnectionBtn="showConnectionBtnVal"
                    :disableConnectionBtn="disableConnectionBtnVal"
                    :showSaveBtn="showSaveBtnVal"
                    :disableSaveBtn="disableSaveBtnVal"
                    :loadingSaveBtn="loadingSaveBtnVal"
                    @close="close()"
                />
            </div>
        </div>
    </modal>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import { required, minLength, maxLength } from "vuelidate/lib/validators";

    import Modal from '@/tools/modal/Modal';
    import loader from '@/tools/loaders/loader1';
    import topArea from './popupParts/topArea';
    import steps from './popupParts/integrationsSteps.vue';
    import bottomArea from './popupParts/bottomArea';
    import extendedVSelect from '@/extends/vue-select';

    export default {
        data() {
            return {
                isOpenUp: [],
                isLoading: false,
                steps: [
                    { number: 1, label: '' },
                    { number: 2, label: '' },
                    { number: 3, label: '' },
                    { number: 4, label: '' },
                ],
                currentStep: 1,
                primaveraData: {
                    defaultUrl: "",
                    defaultSerie: "",
                    defaultSerieConfiguration: "",
                    defaultChargebackReason: "",
                    company: "",
                    username: "",
                    password: "",
                    defaultEndCustomerName: "",
                    defaultEndCustomerTaxNumber: "",
                    defaultArticleListID: "",
                    codePrefix: "",
                    paymentConditions: [],
                    paymentTypes: []
                },
                connectionTested: false
            }
        },
        validations: {
            primaveraData: {
                defaultUrl: {
                    required,
                },
                company: {
                    required,
                },
                username: {
                    required,
                },
                password: {
                    required,
                },
                defaultArticleListID: {
                    required,
                },
                defaultSerie: {
                    required,
                },
                defaultSerieConfiguration: {
                    required,
                },
                codePrefix: {
                    maxLength: maxLength(3)
                },
                paymentConditions: {
                    $each: {
                        externalId: {required}
                    }
                },
                paymentTypes: {
                    $each: {
                        externalId: {required}
                    }
                },
                defaultChargebackReason: {
                    required,
                },
                defaultEndCustomerName: {
                    required,
                },
                defaultEndCustomerTaxNumber: {
                    required,
                }
            },
        },
        created() {
            this.requestPrimaveraSettings().then(res => {
                this.primaveraData = {...this.primaveraData, ...res};
            });
        },
        computed: {
            ...mapGetters([
                'getSelectedIntegration',
                'getPrimaveraSeries',
                'getIsResquestingPrimaveraSeriesLoading',
                'getDocumentTypes',
                'getChargeBackReason',
                'getIsChargeBackReasonsLoading',
                'getPaymentConditions',
                'getIsResquestingPaymentConditionsLoading',
                'getPaymentTypes',
                'getIsPaymentTypesLoading',
                'getIsResquestingErpPaymentTypeLoading',
                'getErpPaymentTypes',
                'getIsPrimaveraSettingsLoading',
                'getIsPrimaveraSettingsSaving'
            ]),
            loadingSaveBtnVal() {
                return this.getIsPrimaveraSettingsSaving;
            },
            disableSaveBtnVal() {
                return this.$v.primaveraData.$invalid;
            },
            showSaveBtnVal() {
                return this.currentStep === 4;
            },
            disableConnectionBtnVal() {
                return  this.$v.primaveraData.defaultUrl.$invalid || this.$v.primaveraData.company.$invalid || this.$v.primaveraData.username.$invalid 
                        || this.$v.primaveraData.password.$invalid || this.$v.primaveraData.defaultArticleListID.$invalid;
            },
            disableNextBtn() {
                if (this.currentStep === 1) {
                    return !this.connectionTested || this.disableConnectionBtnVal;
                } else if (this.currentStep === 2) {
                    return this.$v.primaveraData.defaultSerie.$invalid || this.$v.primaveraData.defaultSerieConfiguration.$invalid || this.$v.primaveraData.paymentConditions.$invalid ||
                    this.$v.primaveraData.defaultChargebackReason.$invalid;
                }
            },
            showNextBtn() {
                return [1, 2, 3].includes(this.currentStep);
            },
            showPrevBtn() {
                return [2, 3, 4].includes(this.currentStep);
            },
            showConnectionBtnVal() {
                return this.currentStep === 1;
            },
            currentIntegration: function () {
                return this.getSelectedIntegration;
            },
            paymentTypesMap() {
                return this.primaveraData.paymentTypes.reduce((map, item) => {
                    map[item.internalId] = item.externalId;
                    
                    return map;
                }, {});
            },
            paymentConditionsMap() {
                return this.primaveraData.paymentConditions.reduce((map, item) => {
                    map[item.internalId] = item.externalId;
                    
                    return map;
                }, {});
            },
            erpPaymentTypesOptionsMap() {
                return this.getErpPaymentTypes.reduce((map, item) => {
                    map[item.id] = item;
                    
                    return map;
                }, {});
            },
            paymentConditionsOptionsMap() {
                return this.getPaymentConditions.reduce((map, item) => {
                    map[item.id] = item;
                    
                    return map;
                }, {});
            },
        },
        methods: {
            ...mapActions([
                'downloadInvoicingIntegrationDetails',
                'requestIntegrationDeactivationViaEmail',
                'testPrimaveraConnection',
                'requestSeries',
                'requestDocumentTypes',
                'requestChargeBackReason',
                'requestPaymentConditions',
                'requestPaymentTypes',
                'requestPrimaveraSettings',
                'disablePrimavera',
                'requestErpPaymentTypes',
                'savePrimaveraSettings',
                'downloadSupplierIntegrations',
                'initSettings',
                'closeModal'
            ]),
            toggleDirection(index) {
                this.$nextTick(() => {
                    const selectRef = this.$refs['select-' + index];

                    if (selectRef) {
                        const selectEl = selectRef.$el || selectRef[0].$el;
                        const parentEl = this.$refs.parentContainer;

                        if (selectEl && parentEl) {
                            const selectRect = selectEl.getBoundingClientRect();
                            const parentRect = parentEl.getBoundingClientRect();

                            // Calculates the parent container space
                            const spaceAbove = selectRect.top - parentRect.top;
                            const spaceBelow = parentRect.bottom - selectRect.bottom;
                            const dropdownHeight = 120;
                            const shouldOpenUp = spaceBelow < dropdownHeight && spaceAbove > spaceBelow;

                            this.$set(this.isOpenUp, index, shouldOpenUp);
                        }
                    }
                });
            },
            erpPaymentTypesInput(event, type) {
                const internalId = type.id.toLowerCase();
                const index = this.primaveraData.paymentTypes.findIndex(pt => pt.internalId === internalId);

                if (index !== -1) {
                    this.$set(this.primaveraData.paymentTypes[index], 'externalId', event.id);
                }
            },
            getErpPaymentTypesValue(type) {
                const externalId = this.paymentTypesMap[type.id.toLowerCase()];
                
                return this.erpPaymentTypesOptionsMap[externalId] || null;
            },
            paymentConditionsInput(event, type) {
                const internalId = type.id.toLowerCase();
                const index = this.primaveraData.paymentConditions.findIndex(pc => pc.internalId === internalId);

                if (index !== -1) {
                    this.$set(this.primaveraData.paymentConditions[index], 'externalId', event.id);
                }
            },
            getPaymentConditionsValue(type) {
                const externalId = this.paymentConditionsMap[type.id.toLowerCase()];
                
                return this.paymentConditionsOptionsMap[externalId] || null;
            },
            initPaymentConditions() {
                this.primaveraData.paymentConditions = this.getDocumentTypes.map(type => ({
                    'internalId': type.id.toLowerCase(),
                    'externalId': '',
                }));
            },
            initPaymentTypes() {
                this.primaveraData.paymentTypes = this.getPaymentTypes.map(type => ({
                    'internalId': type.id.toLowerCase(),
                    'externalId': '',
                }));
            },
            getChargeBackReasonValue(reasonId) {
                return this.getChargeBackReason.find(reason => reason.id === reasonId) || null;
            },
            getSeriesValue(serieId) {
                return this.getPrimaveraSeries.find(series => series.id === serieId) || null;
            },
            chargeBackReasonInput(event) {
                this.$set(this.primaveraData, 'defaultChargebackReason', event.id);
            },
            seriesInput(event) {
                this.$set(this.primaveraData, 'defaultSerie', event.id);
                this.$set(this.primaveraData, 'defaultSerieConfiguration', event.map);
            },
            async testConnection() {
                const res = await this.testPrimaveraConnection(this.primaveraData);
                this.connectionTested = res;
                this.isLoading = true;

                if (res) {
                    const dataChecks = [
                        { getter: 'getPrimaveraSeries', requestMethod: this.requestSeries },
                        { getter: 'getDocumentTypes', requestMethod: this.requestDocumentTypes },
                        { getter: 'getChargeBackReason', requestMethod: this.requestChargeBackReason },
                        { getter: 'getPaymentConditions', requestMethod: this.requestPaymentConditions },
                        { getter: 'getPaymentTypes', requestMethod: this.requestPaymentTypes },
                        { getter: 'getErpPaymentTypes', requestMethod: this.requestErpPaymentTypes },
                    ];

                    const dataRequests = dataChecks.map(item => {
                        if (this[item.getter].length === 0) {
                            return item.requestMethod();
                        }
                    }).filter(Boolean);

                    await Promise.all(dataRequests);

                    if (this.primaveraData.paymentConditions.length === 0) {
                        this.initPaymentConditions();
                    }

                    if (this.primaveraData.paymentTypes.length === 0) {
                        this.initPaymentTypes();
                    }
                }

                this.isLoading = false;
            },
            nextStep() {
                this.currentStep++;
            },
            prevStep() {
                this.currentStep--;
            },
            switchStep(step) {
                if (this.disableNextBtn) {
                    return;
                }

                this.currentStep = step.number;
            },
            clickDeactivate() {
                this.disablePrimavera().then(response => {
                    this.close()
                }).catch(err => {
                    this.close();
                })
            },
            close() {
                this.closeModal();
            },
            savePrimaveraData() {
                this.savePrimaveraSettings(this.primaveraData).then(res => {
                    this.close();
                    this.downloadSupplierIntegrations();
                    this.initSettings();
                }).catch(err => {
                    this.close();
                })
            }
        },
        components: {
            topArea,
            bottomArea,
            Modal,
            loader,
            vSelect: extendedVSelect,
            steps
        }
    }
</script>

<style lang="scss" scoped>
    .payment-height {
        height: 1.875rem;
    }

    .payment-labels {
        height: 1.375rem;
    }

    .row-height {
        height: 4.375rem;
    }

    .payment-types {
        max-height: 13rem;
        overflow-y: auto;
    }

    .min-section-height {
        min-height: 23rem;
    }

    .min-payment-height {
        min-height: 12.688rem;
    }
</style>

<style lang="scss">
    @import "../../../assets/scss/variables";

    .smaller-select {
        .dropdown-toggle {
            height: 30px !important;

            .vs__actions {
                top: 3px !important;
            }

            .selected-tag, & input[type=search] {
                height: 28px !important;
                margin: 0 !important;
                line-height: 1.4rem !important;
                font-size: 11px !important;
            }
        }
        
        .dropdown-menu {
            font-size: 11px !important;
            color: black;
            height: 120px !important;
            position: absolute !important;
            
            li[role=option] a {
                padding-left: 15px !important;
            }
        }

        .open-indicator {
            height: 20px !important;
        }
    }

    .black-text {
        .dropdown-menu {
            color: black;
        }
    }

    .open-up {    
        .dropdown-menu {
            position: absolute;
            top: -120px;
        }
    }

    .v-select.single.primavera-select .dropdown-toggle {
        height: 37px;
    }

    .v-select.open-up.open.smaller-select .dropdown-toggle { 
        border-top-color: transparent;
        border-top-left-radius: 0;
        border-top-right-radius: 0;

        border-bottom-color: $light;
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
    }
</style>



// WEBPACK FOOTER //
// primaveraIntegrate.vue?32c28222